import Hero from '../sections/Hero.jsx';
import Path from '../sections/Path.jsx';
import Numbers from '../sections/Numbers.jsx';
import Teachers from '../sections/Teachers.jsx';
import Parents from '../sections/Parents.jsx';
import Admissions from '../sections/Admissions.jsx';
import Portal from '../sections/Portal.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor, schoolJsonLd } from '../seo/routes.js';

export default function Home() {
  return (
    <>
      <Seo {...metaFor('/')} path="/" jsonLd={schoolJsonLd()} />
      <Hero />
      <Path />
      <Numbers />
      <Teachers />
      <Parents />
      <Admissions />
      <Portal />
    </>
  );
}
